<template>
  <div class="step-container scrollPosition">
    <div class="step-header">
      <h2 class="step-title">Basis-Daten</h2>
      <p class="step-text">Geben Sie die Eckdaten der Immobilie an.</p>
    </div>
    <div class="step-body">
      <div class="row gx-5 justify-content-center">
        <div class="col-md-6">
          <InputRange
            id="ws1_s1"
            min="1950"
            :max="currentYear"
            v-model="fields.gebaeudeBaujahr.value"
            :defaultValue="fields.gebaeudeBaujahr.default"
            label="Baujahr"
            unit=""
            @update:modelValue="validate('gebaeudeBaujahr')"
            :state="fields.gebaeudeBaujahr.state"
          />
        </div>
        <div class="col-md-6">
          <InputRange
            id="ws1_s2"
            min="20"
            max="500"
            v-model="fields.whgNutzflaecheM2.value"
            :defaultValue="fields.whgNutzflaecheM2.default"
            label="Wohnnutzfläche"
            unit="m²"
            @update:modelValue="validate('whgNutzflaecheM2')"
            :state="fields.whgNutzflaecheM2.state"
          />
        </div>
      </div>
    </div>
    <div class="step-footer">
      <div class="row align-items-center">
        <div class="col-md-4 col-6">
          <button
            class="back-btn"
            @click="goBack()"
          >
            Zurück
          </button>
        </div>
        <div class="col-md-4 col-6 next-container">
          <button
            class="next-btn"
            @click="goNext()"
          >
            Weiter
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import InputRange from "@/components/shared/InputRange.vue";
import {
  getFromStorage,
  saveToStorage,
  checkValidFields,

  validateField,
  setDefaults,
} from "@/utils.js";
export default {
  name: "wohnung-step-2",
  components: {
    InputRange,
  },
  computed: {
    currentYear() {
      return new Date().getFullYear().toString();
    },
  },
  data() {
    return {
      fields: {
        gebaeudeBaujahr: {
          default: "2000",
          validators: ["required", "min:0", `max:${new Date().getFullYear()}`],
        },
        whgNutzflaecheM2: {
          default: "75",
          validators: ["required", "min:10"],
        },
      },
    };
  },
  methods: {
    goBack() {
      setDefaults(this.fields);
      saveToStorage(this.fields);
      this.$router.push("/wohnung-step-1");
    },
    goNext() {
      setDefaults(this.fields);
      saveToStorage(this.fields);
        this.$router.push("/wohnung-step-3");
    },
    validate(name) {
      const field = this.fields[name];
      field.state = validateField(field.value, field.validators);
    },
  },
  mounted() {
    this.$emit("setStep", "wohnung", 3);
    getFromStorage(this.fields);
    checkValidFields(this.fields);
  },
};
</script>
<style scoped>
.step-body {
  margin-bottom: 55px;
}
.step-body .row {
  row-gap: 55px;
}
@media only screen and (max-width: 768px) {
  .step-body {
    margin-bottom: 55px;
  }
}
</style>
